const SPARK_CATEGORIES = [
  { title: '3CX Licensing', url: '/collections/3cx-licensing', terms: ['3cx','3cx pro','3cx license','3cx licensing','annual license','pro license','simultaneous calls','sc license','sc capacity','pbx'] },
  { title: 'Rural Internet', url: '/collections/rural-internet', terms: ['rural internet','internet','5g','4g','4g lte','lte','wireless internet','rv internet','byod','true blue','neon pink','ultra red','orange byod'] },
  { title: 'VoIP & UC', url: '/collections/voip-uc-1', terms: ['voip','sip','ip phone','conference','uc','unified communications'] },
  { title: 'Networking', url: '/collections/networking-1', terms: ['network','switch','router','wifi','wi-fi','access point','ethernet'] },
  { title: 'Business Equipment', url: '/collections/business-equipment-1', terms: ['business equipment','paging','intercom','audio','telecom','speaker'] },
  { title: 'Headsets & Accessories', url: '/collections/headsets-accessories-1', terms: ['headset','headsets','accessory','adapter','cable','ear cushion','mount'] },
  { title: 'Phones & Accessibility', url: '/collections/phones-accessibility', terms: ['phone','telephone','accessibility','amplified','corded','cordless'] },
  { title: 'Shop All', url: '/collections/all', terms: ['all products','catalog','shop all'] }
];

const SPARK_TYPES = [
  { title: '3CX License', terms: ['3cx','3cx pro','3cx license','3cx licensing','annual license','simultaneous calls','sc license','sc capacity','pbx'] },
  { title: 'Rural Internet', terms: ['rural internet','internet','5g','4g','4g lte','lte','wireless internet','rv internet','byod'] },
  { title: 'SIP Phones', terms: ['sip phone','voip phone','desk phone','ip phone'] },
  { title: 'Switches', terms: ['switch','ethernet','poe','network switch'] },
  { title: 'Headsets', terms: ['headset','ehs','ear cushion'] },
  { title: 'Access Points', terms: ['access point','wifi','wi-fi','wireless','ap'] },
  { title: 'Routers', terms: ['router','cellular router','network gateway'] },
  { title: 'Paging and Intercom Equipment', terms: ['paging','intercom','door phone','paging adapter'] },
  { title: 'Paging and Intercom Speakers', terms: ['speaker','paging speaker','horn','ceiling speaker'] },
  { title: 'Conferencing Equipment', terms: ['conference','conferencing','meeting','speakerphone'] },
  { title: 'VoIP Gateways and ATAs', terms: ['ata','analog adapter','voip gateway','gateway'] },
  { title: 'Special Needs', terms: ['accessibility','amplified','big button','visual ringer','special needs'] },
  { title: 'Telephone Accessories', terms: ['telephone accessory','handset','cord','adapter','phone accessory'] },
  { title: 'Battery Backup and Surge Protection', terms: ['battery','ups','surge','power protection','pdu'] }
].map((item) => ({ ...item, url: `/collections/types?q=${encodeURIComponent(item.title)}` }));

const escapeHtml = (value = '') => String(value)
  .replaceAll('&', '&amp;')
  .replaceAll('<', '&lt;')
  .replaceAll('>', '&gt;')
  .replaceAll('"', '&quot;')
  .replaceAll("'", '&#039;');

function getVendors() {
  const source = document.querySelector('[data-spark-vendors]');
  if (!source) return [];
  try {
    return JSON.parse(source.textContent || '[]').filter((brand) => brand && !['Miscellaneous Brands','NEC SL1100 SL2100'].includes(brand));
  } catch {
    return [];
  }
}

function imageUrl(product) {
  if (!product?.featured_image) return '';
  return typeof product.featured_image === 'string' ? product.featured_image : (product.featured_image.url || '');
}

function productRow(product) {
  const img = imageUrl(product);
  const vendor = product.vendor ? `<span>${escapeHtml(product.vendor)}</span>` : '';
  const price = product.price ? `<strong>${escapeHtml(product.price)}</strong>` : '';
  return `<a class="spark-smart-product" href="${escapeHtml(product.url)}" data-smart-link>
    <span class="spark-smart-product__image">${img ? `<img src="${escapeHtml(img)}" alt="" loading="lazy">` : '<i>SPARK</i>'}</span>
    <span class="spark-smart-product__copy"><b>${escapeHtml(product.title)}</b><small>${vendor}${price}</small></span>
  </a>`;
}

function linkGroup(title, items, modifier = '') {
  if (!items.length) return '';
  return `<section class="spark-smart-group ${modifier}"><h3>${escapeHtml(title)}</h3><div class="spark-smart-links">${items.map((item) => `<a href="${escapeHtml(item.url)}" data-smart-link>${escapeHtml(item.title)}<span>→</span></a>`).join('')}</div></section>`;
}

function productGroup(products) {
  if (!products.length) return '';
  return `<section class="spark-smart-group spark-smart-group--products"><h3>Products</h3><div class="spark-smart-products">${products.map(productRow).join('')}</div></section>`;
}

function queryGroup(queries) {
  if (!queries.length) return '';
  const items = queries.slice(0, 4).map((query) => ({ title: query.text || query.styled_text || '', url: query.url || `/search?q=${encodeURIComponent(query.text || '')}` })).filter((item) => item.title);
  return linkGroup('Suggested searches', items, 'spark-smart-group--queries');
}

function attachSmartSearch(input) {
  if (!input || input.dataset.sparkSmartSearch === '1') return;
  input.dataset.sparkSmartSearch = '1';

  const form = input.closest('form');
  const host = input.closest('.spark-search') || input.closest('search-page-input-component') || input.parentElement;
  if (!host) return;
  host.classList.add('spark-smart-host');

  const dropdown = document.createElement('div');
  dropdown.className = 'spark-smart-results';
  dropdown.hidden = true;
  dropdown.setAttribute('role', 'listbox');
  dropdown.setAttribute('aria-label', 'Search suggestions');
  host.appendChild(dropdown);

  input.setAttribute('autocomplete', 'off');
  input.setAttribute('aria-autocomplete', 'list');
  input.setAttribute('aria-expanded', 'false');

  const vendors = getVendors();
  const cache = new Map();
  let timer = null;
  let controller = null;
  let active = -1;

  const close = () => {
    dropdown.hidden = true;
    input.setAttribute('aria-expanded', 'false');
    active = -1;
  };

  const open = () => {
    dropdown.hidden = false;
    input.setAttribute('aria-expanded', 'true');
  };

  const links = () => [...dropdown.querySelectorAll('[data-smart-link]')];
  const setActive = (index) => {
    const all = links();
    if (!all.length) return;
    active = ((index % all.length) + all.length) % all.length;
    all.forEach((link, i) => link.classList.toggle('is-active', i === active));
    all[active]?.scrollIntoView({ block: 'nearest' });
  };

  const render = (term, payload) => {
    const q = term.toLowerCase();
    const results = payload?.resources?.results || {};
    const products = (results.products || []).slice(0, 6);
    const endpointCollections = (results.collections || []).map((collection) => ({ title: collection.title, url: collection.url }));
    const termMatches = (item) => {
      const haystack = [item.title, ...(item.terms || [])].join(' ').toLowerCase();
      return haystack.includes(q) || q.split(/\s+/).every((part) => haystack.includes(part));
    };
    const categoryMatches = SPARK_CATEGORIES.filter(termMatches).slice(0, 5);
    const categories = [...categoryMatches, ...endpointCollections].filter((item, index, array) => item?.title && item?.url && array.findIndex((candidate) => candidate.url === item.url) === index).slice(0, 6);
    const typeMatches = SPARK_TYPES.filter(termMatches).slice(0, 6);
    const brandMatches = vendors.filter((brand) => brand.toLowerCase().includes(q)).slice(0, 6).map((brand) => ({ title: brand, url: `/collections/vendors?q=${encodeURIComponent(brand)}` }));
    const queries = results.queries || [];

    const markup = [
      linkGroup('Categories', categories),
      linkGroup('Product types', typeMatches, 'spark-smart-group--types'),
      linkGroup('Brands', brandMatches, 'spark-smart-group--brands'),
      productGroup(products),
      queryGroup(queries)
    ].join('');

    dropdown.innerHTML = markup || `<div class="spark-smart-empty"><b>No close match yet.</b><span>Press Enter to search the full SPARK catalog for “${escapeHtml(term)}”.</span></div>`;
    dropdown.insertAdjacentHTML('beforeend', `<a class="spark-smart-view-all" href="/search?type=product&q=${encodeURIComponent(term)}" data-smart-link>Search all products for “${escapeHtml(term)}” <span>→</span></a>`);
    dropdown.querySelectorAll('[data-smart-link]').forEach((link, index) => link.addEventListener('mouseenter', () => setActive(index)));
    active = -1;
    open();
  };

  const fetchResults = async (term) => {
    const cacheKey = term.toLowerCase();
    if (cache.has(cacheKey)) {
      render(term, cache.get(cacheKey));
      return;
    }
    controller?.abort();
    controller = new AbortController();
    const url = new URL('/search/suggest.json', window.location.origin);
    url.searchParams.set('q', term);
    url.searchParams.set('resources[type]', 'product,collection,query');
    url.searchParams.set('resources[limit]', '8');
    url.searchParams.set('resources[limit_scope]', 'each');
    url.searchParams.set('resources[options][unavailable_products]', 'hide');
    url.searchParams.set('resources[options][fields]', 'title,product_type,variants.title,variants.sku,vendor,tag');
    try {
      const response = await fetch(url, { signal: controller.signal, headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error(`Predictive search ${response.status}`);
      const payload = await response.json();
      cache.set(cacheKey, payload);
      render(term, payload);
    } catch (error) {
      if (error.name !== 'AbortError') render(term, { resources: { results: {} } });
    }
  };

  input.addEventListener('input', () => {
    const term = input.value.trim();
    clearTimeout(timer);
    if (term.length < 2) {
      close();
      return;
    }
    timer = setTimeout(() => fetchResults(term), 160);
  });

  input.addEventListener('focus', () => {
    if (input.value.trim().length >= 2 && dropdown.innerHTML) open();
  });

  input.addEventListener('keydown', (event) => {
    const all = links();
    if (event.key === 'Escape') {
      close();
      return;
    }
    if (!dropdown.hidden && all.length && (event.key === 'ArrowDown' || event.key === 'ArrowUp')) {
      event.preventDefault();
      event.stopPropagation();
      setActive(event.key === 'ArrowDown' ? active + 1 : active - 1);
      return;
    }
    if (!dropdown.hidden && event.key === 'Enter' && active >= 0 && all[active]) {
      event.preventDefault();
      window.location.href = all[active].href;
    }
  });

  dropdown.addEventListener('mousedown', (event) => event.preventDefault());
  document.addEventListener('click', (event) => {
    if (!host.contains(event.target)) close();
  });

  form?.addEventListener('submit', () => close());
}

function initSparkSmartSearch() {
  document.querySelectorAll('.spark-search input[type="search"], .search-page-input').forEach(attachSmartSearch);
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initSparkSmartSearch, { once: true });
else initSparkSmartSearch();

document.addEventListener('shopify:section:load', initSparkSmartSearch);
